<template>
  <div class="q-pa-md">
    <span
      style="cursor: pointer"
      class="row justify-end q-mt-md q-mb-md"
      @click="voltar"
    >
      <q-icon label="voltar" color="grey" size="sm" name="arrow_back_ios" />
      <span style="color: #8a8a8a; font-size: 16px">Voltar</span>
    </span>

    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      :columns="columns"
      class="tabela-tamanho-fixo"
      dense
      :loading="disable"
      title-class="text-brand-5 text-weight-bold"
      v-model:pagination="pagination"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template #body-cell-centro="props">
        <q-td>
          <span>{{ props.row.cost_center_code }}</span>
          <span class="q-mr-sm q-ml-sm">-</span>
          <span>{{ props.row.cost_center_nam }}</span>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "nome",
    label: "Nome",
    field: "nome",
    align: "left",
  },
  {
    name: "sap",
    label: "ID",
    field: "sap",
    align: "left",
  },
  {
    name: "cargo",
    label: "Cargo",
    field: "cargo",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    field: "email",
    align: "left",
  },
  {
    name: "funcao",
    label: "Função",
    field: "funcao",
    align: "left",
  },
  {
    name: "centro",
    label: "Centro de Custo",
    field: "centro",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
export default {
  props: ["atualizar"],
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const editar = ref("");

    const id = route.params.id;
    const router = useRouter();
    const voltar = () => {
      router.back();
    };

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getPessoas = async (page = 1, rowsPerPage = 15) => {
      let response = await store.dispatch("processos/getPessoas", {
        id: id,
        per_page: rowsPerPage,
        page: page,
        search: filter.value,
      });

      rows.value = response.data.data;
      pagination.value.rowsPerPage = response.data.per_page;
      pagination.value.rowsNumber = response.data.total;
      pagination.value.page = response.data.current_page;

      disable.value = false;
    };

    onMounted(getPessoas);

    const editarRow = async (id, nome) => {
      try {
        await store.dispatch("processos/editarFuncao", {
          nome,
          id,
        });

        $q.notify({
          message: "Linha editada com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getPessoas();
      } catch (error) {
        $q.notify({
          message: "Erro a o editar linha",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getPessoas(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getPessoas();
        }, 1000);
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getPessoas();
      }
    );

    return {
      columns,
      rows,
      getPessoas,
      pagination,
      handleRequest,
      disable,
      filter,
      voltar,
      editar,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      editarRow,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
